import Api from '@/services/Api'

export default {
  // Free Samples
  fetchFreeSamples () {
    return Api().get('freeSamples')
  },

  getLimitedFreeSamples (page, rowsPerPage, search, sentOrNot) {
    return Api().post('limitedFreeSamples/', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      sentOrNot: sentOrNot
    })
  },
  getPendingFreeSamples () {
    return Api().get('pendingFreeSamples')
  },
  getMyPendingFreeSamples (id) {
    return Api().get('pendingMyFreeSamples/' + id)
  },

  countFreeSamples (search, sentOrNot) {
    return Api().post('freeSampleCount', {
      search: search,
      sentOrNot: sentOrNot
    })
  },

  addFreeSample (params) {
    return Api().post('freeSamples', params)
  },

  updateFreeSample (params) {
    return Api().put('freeSample/' + params.id, params)
  },

  getFreeSample (params) {
    return Api().get('freeSample/' + params.id)
  },

  deleteFreeSample (id) {
    return Api().delete('freeSample/' + id)
  },

  getFreeSampleOrders () {
    return Api().get('freeSampleOrders/')
  },

  getFreeSampleOrder (id) {
    return Api().get('freeSampleOrders/' + id)
  },

  getSampleOrderHistory (customerID) {
    return Api().get('getSampleOrderHistory/' + customerID)
  },

  // End Free Samples
  // Free Sample Packs

  getFreeSamplePacks (token) {
    return Api().get('freeSamplePacks')
  },

  getFreeSamplePack (id) {
    return Api().get('freeSamplePack/' + id)
  },

  createFreeSamplePack (freeSamplePack) {
    return Api().post('freeSamplePacks', freeSamplePack)
  }

  // End Free Sample Packs
}



// WEBPACK FOOTER //
// ./src/services/FreeSampleService.js